import {
  FETCH_RETURNS, FETCH_RETURNS_SUCCESS, FETCH_RETURNS_FAILURE, RESET_RETURNS,
} from '../actions/returns';

import {
  FETCH_NEW_LABEL, FETCH_NEW_LABEL_SUCCESS, FETCH_NEW_LABEL_FAILURE,
} from '../actions/label';

import {
  SUBMIT_RETURN_ORDER_SUCCESS,
} from '../actions/order';

import { flagEnabled } from '../helpers/featureFlags';

const INITIAL_STATE = { loading: true, returns: [] };

export default function (state = INITIAL_STATE, action) {
  let returnsList;

  switch (action.type) {
    case FETCH_RETURNS:
      return { ...state, loading: true, requested: true };
    case FETCH_RETURNS_SUCCESS:
      returnsList = action.payload.returns;
      // It's a digital returns feature flag.
      // DSM environment can be unstable and it relies on UPS calls.
      // In case there are issues with non digital returns
      // this feature flag will remove those items from a display
      if (flagEnabled('disableNonDigitalReturns') && returnsList) {
        returnsList = returnsList.filter(returnItem => returnItem.returnInitiation.returnSource !== 'UPSStore');
      }

      return {
        ...state, returns: returnsList, loading: false, error: null, cacheValid: true,
      };
    case FETCH_RETURNS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_NEW_LABEL:
      return { ...state, newLabelLoading: true };
    case FETCH_NEW_LABEL_SUCCESS:
      return {
        ...state,
        returns: state.returns.map((returnItem) => {
          if (action.payload.returnId === returnItem.returnOrderId) {
            return Object.assign({}, returnItem, {
              returnInitiation: Object.assign({}, returnItem.returnInitiation, {
                shippingLabels: [].concat(returnItem.returnInitiation.shippingLabels, [
                  Object.assign({}, action.payload.label, {
                    packageStatus: 'Pending',
                  }),
                ]),
              }),
            });
          }

          return returnItem;
        }),
        newLabelLoading: false,
        newLabelError: null,
      };
    case FETCH_NEW_LABEL_FAILURE:
      return { ...state, newLabelLoading: false, newLabelError: action.payload };
    case SUBMIT_RETURN_ORDER_SUCCESS:
      return { ...state, returns: [].concat(state.returns, [action.payload]), cacheValid: false };
    case RESET_RETURNS:
      return INITIAL_STATE;
    default:
      return state;
  }
}
